import { mirrorX } from "apparatus/draw";
import { CenterR, Segments } from "apparatus/library/common";
import { Group, Path } from "paper";
import { breakPath, setDefaultStyle } from "../../draw";
export class WashBottle {
    render(appearance) {
        let size = appearance.size;
        let totalHeight = 30 + size;
        let width = Math.min(40, 15 + size / 5);
        let bottle = new Path(Segments([[12, 0]], [[12, 10], undefined, [0, 10]], [[width, 30], [0, -15]], [[width, totalHeight - 5], undefined, [0, 4]], [[width - 5, totalHeight]]));
        mirrorX(bottle);
        let liquidMask = bottle.clone();
        setDefaultStyle(bottle);
        // Draw the tube.
        let tube = new Path(Segments([[4, totalHeight - 20]], [[4, -40], undefined, [0, -15]], [[-15, -55], [10, -8]], [[-70, -10]], [[-70, 0]], [[-15, -45], undefined, [9, -7]], [[-4, -36], [0, -8]], [[-4, totalHeight - 20]]));
        let newTube = breakPath(tube, 4);
        setDefaultStyle(newTube);
        // Draw the cap.
        let cap = CenterR(0, 0, 25, 15).toShape();
        setDefaultStyle(cap);
        cap.fillColor = "white";
        let graphic = new Group([bottle, newTube, cap]);
        return {
            graphic: graphic,
            hitShape: graphic.bounds.toShape(),
            liquidMask: liquidMask,
            snapping: graphic.placeable(),
        };
    }
}
WashBottle.properties = {
    label: "Wash Bottle",
    canContainLiquids: true,
    defaultAppearance: {
        size: 100
    },
    flippable: true,
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 70, max: 150
        }
    ],
};
